import { useTranslation } from 'react-i18next';
import { DEFAULT_PRIMARY_ACTION, getPageMeta, type HeaderAction } from './navigation';

type TranslatedAction = { label: string; to: string };

export type PageHeading = {
  title: string;
  subtitle: string | null;
  primaryAction: TranslatedAction;
  secondaryAction: TranslatedAction | null;
};

/** Title, subtitle and header actions for a route, in the active language. */
export function usePageHeading(pathname: string): PageHeading {
  const { t } = useTranslation('layout');
  const meta = getPageMeta(pathname);
  const page = t(`pages.${meta.id}`, { returnObjects: true });
  const action = (value: HeaderAction): TranslatedAction => ({
    label: t(`actions.${value.label}`),
    to: value.to,
  });

  return {
    title: page.title,
    subtitle: 'subtitle' in page ? page.subtitle : null,
    primaryAction: action(meta.primaryAction ?? DEFAULT_PRIMARY_ACTION),
    secondaryAction: meta.secondaryAction ? action(meta.secondaryAction) : null,
  };
}
